var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0645 0.5C5.43709 0.5 0.0644531 5.87264 0.0644531 12.5C0.0644531 18.1275 3.93901 22.8498 9.16573 24.1467V16.1672H6.69133V12.5H9.16573V10.9198C9.16573 6.83552 11.0142 4.9424 15.0241 4.9424C15.7845 4.9424 17.0963 5.09168 17.6329 5.24048V8.56448C17.3497 8.53472 16.8577 8.51984 16.2467 8.51984C14.2792 8.51984 13.5189 9.26528 13.5189 11.203V12.5H17.4385L16.7651 16.1672H13.5189V24.4122C19.4608 23.6946 24.0649 18.6354 24.0649 12.5C24.0645 5.87264 18.6918 0.5 12.0645 0.5Z",
    fill: "#043873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0644531 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5e490066e668296f9f332a35c4c71ebb.svg";
export { ForwardRef as ReactComponent };